<template>
  <div class="tw-border-t tw-border-0 tw-border-infinity-card-border tw-border-solid">
    <buy-button
        :item="item"
        :label="label"
        variant="itemTileButton"></buy-button>
  </div>
</template>
<script>
import BuyButton from "../../shared/buy-button";
import SoundKit from "../../../models/soundkit";
import Beat from "../../../models/beat";
import Song from "../../../models/song";
import BeatTape from "../../../models/beat-tapes"
import Service from "../../../models/service";
import ServiceQuote from "../../../models/ServiceQuote";

export default {
  props: {
    label: {
      type: String
    },
    item: {
      type: [SoundKit, Beat, Song, BeatTape, Service, ServiceQuote],
      required: true
    }
  },
  components: {
    BuyButton
  }
};
</script>
